import { Chip } from '@mui/material';

interface FacturacionBadgeProps {
  facturado: boolean;
}

export function FacturacionBadge({ facturado }: FacturacionBadgeProps): JSX.Element {
  return (
    <Chip
      label={facturado ? 'Facturado' : 'No facturado'}
      size="small"
      color={facturado ? 'success' : 'default'}
    />
  );
}
